/*
 * Adds products through Shopify's Cart API, then refreshes and opens the
 * house bag panel (bag.js, revived 2026-09-10). Falls back to the /cart
 * page only if the panel script failed to load.
 */

const config = JSON.parse(document.getElementById('sbmd-config').textContent);

async function addToShopifyCart(productKeys, quantity = 1) {
  const items = productKeys
    .map((key) => config.products[key]?.variantId)
    .filter(Boolean)
    .map((id) => ({ id, quantity }));

  if (!items.length) return;

  const response = await fetch(`${config.routes.cartAdd}.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({ items })
  });

  if (!response.ok) throw new Error(`Shopify cart returned ${response.status}`);

  if (window.SBMDbag) {
    await window.SBMDbag.refresh(true);
    window.SBMDbag.open();
    return;
  }

  window.location.assign(config.routes.cart);
}

async function addVariants(variantIds, quantity = 1) {
  const items = variantIds.filter(Boolean).map((id) => ({ id: Number(id), quantity }));
  if (!items.length) return;

  const response = await fetch(`${config.routes.cartAdd}.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({ items })
  });

  if (!response.ok) throw new Error(`Shopify cart returned ${response.status}`);

  if (window.SBMDbag) {
    await window.SBMDbag.refresh(true);
    window.SBMDbag.open();
    return;
  }

  window.location.assign(config.routes.cart);
}

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-add], [data-add-variant]');
  if (!button) return;

  event.preventDefault();
  button.disabled = true;
  const qtyInput = button.closest('[data-buy]')?.querySelector('[data-qty]');
  const quantity = clampQty(qtyInput ? qtyInput.value : 1);

  try {
    if (button.dataset.addVariant) {
      await addVariants(button.dataset.addVariant.split(' '), quantity);
    } else {
      await addToShopifyCart(button.dataset.add.split(' '), quantity);
    }
  } catch (error) {
    console.error('Unable to add items to the Shopify cart.', error);
  } finally {
    button.disabled = false;
  }
});

/* quantity steppers (1-99) — shared by every buy surface */
function clampQty(v) {
  return Math.min(99, Math.max(1, parseInt(v, 10) || 1));
}

document.addEventListener('click', (event) => {
  const step = event.target.closest('[data-qty-step]');
  if (!step) return;
  const input = step.closest('.qty-pill')?.querySelector('[data-qty]');
  if (!input) return;
  input.value = clampQty(Number(input.value || 1) + Number(step.dataset.qtyStep));
});

document.addEventListener('change', (event) => {
  if (event.target.matches?.('[data-qty]')) event.target.value = clampQty(event.target.value);
});

window.SBMDShopifyCart = { add: addToShopifyCart };
